export function setZips(state, items) {
   state.zips = items;
}

export function setLoaded(state, loaded) {
   state.loaded = loaded;
}

export function reset(state) {
   state.zips = [];
   state.loaded = false;
}
